import React, {ReactElement} from 'react';
import {Typography} from '@customink/pigment-react';
import {useTheme} from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import {useAppSelector, useDomPurify} from '../../hooks';
import {useGetStoreDetailsQuery} from '../../api/storesApi';
import ShareLinkDialog from './ShareDialog';
import Tracker from './Tracker';
import './index.scss';

type Props = {
  storeSlug: string;
};

const StoreProductDetailSidebar: React.FC<Props> = ({
  storeSlug
}: Props): ReactElement => {
  useGetStoreDetailsQuery(storeSlug);
  const storeDetails = useAppSelector(state => state.stores.storeDetails);
  // may need to revisit this
  const storeDescription = storeDetails?.description;
  const {sanitizer} = useDomPurify();
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down('md'));

  const StoreDescription = () => {
    // PENDING: [Phelan Lucky] temporarily hard-coded, remove once fundraiser is over
    return storeDescription && storeSlug !== 'phelan-lucky' ? (
      <div className="storeProductDetailSidebar-description">
        <Typography variant="subHeading" gutterBottom>
          About
        </Typography>
        <div
          className="description"
          dangerouslySetInnerHTML={{__html: sanitizer(storeDescription)}}
        />
      </div>
    ) : null;
  };

  return (
    <div className={`storeProductDetailSidebar${mobile ? ' mobile' : ''}`}>
      <StoreDescription />
      <Tracker storeSlug={storeSlug} />
      <ShareLinkDialog storeSlug={storeSlug} mobile={mobile} />
    </div>
  );
};

export default StoreProductDetailSidebar;
